<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eMGxmE/tc-custom/9780061978357.jpg?1732052123881" alt="This image is the cover for the book Waterloo Station"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Waterloo Station
      </h1>
      <p class="bookDescription body article font2">
        <p>These were days of uncertainty and peril, of noble deeds and great sacrifice.</p><p>An exciting time to be young and adventurous . . . but a dangerous time to fall in love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emily Grayson
      </h2>
      
      <p class="authorDescription body article"><P>Emily Grayson is the author of four previous novels, <I>The Gazebo</I>, <I>The Observatory</I>, <I>The Fountain</I>, and <I>Waterloo Station</I>. She lives in New York City with her husband and children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26280937